<script>
  import AlertModal from '../Modals/AlertModal.svelte';
  import { showAlertModal } from '../../stores/modals.js';
  import { storage } from '../../../firebase';
  import { ref, listAll, getDownloadURL } from 'firebase/storage';
  import { onMount } from 'svelte';

  let images = [];

  onMount(async () => {
    console.log('Début du chargement des images');
    const storageRef = ref(storage, 'photos carroussel');
    try {
      const result = await listAll(storageRef);
      console.log('Images trouvées:', result.items.length);
      const imagePromises = result.items.map(async (item, index) => {
        const url = await getDownloadURL(item);
        console.log('URL récupérée pour image', index, ':', url);
        return {
          id: index,
          url: url
        };
      });
      images = await Promise.all(imagePromises);
      console.log('Toutes les images ont été chargées:', images);
    } catch (error) {
      console.error('Erreur lors de la récupération des images:', error);
    }
  });

  function openShowAlertModal() {
    showAlertModal.set(true);
  }
</script>

<section id="cta" class="cta">
  <div id="photos-container" class="tw-flex tw-flex-col tw-items-center container" data-aos="zoom-in" style="position:relative;">
    <div class="tw-text-3xl tw-text-white tw-mb-4">Nos activités</div>
    
    {#if images.length > 0}
      <div class="image-grid tw-w-full">
        {#each images as image}
          <div class="image-item">
            <a href={image.url} target="_blank" rel="noopener noreferrer">
              <img src={image.url} alt="Photo activité" />
            </a>
          </div>
        {/each}
      </div>
    {:else}
      <div class="tw-text-white">Chargement des images...</div>
    {/if}


  </div>

  <AlertModal/>
</section>

<style>
  .cta {
    background: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url("/assets/img/cta-bg.jpg") fixed center center;
    background-size: cover;
    padding: 60px 0;
  }
.image-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
  margin: 2rem 0;
  width: 100%;
  box-sizing: border-box;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
  box-sizing: border-box;
}
.image-item {
  cursor: pointer;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
  transition: transform 0.2s;
}
.image-item:hover {
  transform: scale(1.03);
}
.image-item img {
  width: 100%;
  height: 280px;
  object-fit: cover;
}



.close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  margin: 0;
  padding: 0.25rem 0.9rem;
  border: none;
  background: #222;
  color: #fff;
  border-radius: 50px;
  cursor: pointer;
  font-size: 1.2rem;
  opacity: 0.85;
  z-index: 10;
}
.close-btn:hover {
  background: #444;
  opacity: 1;
}
</style>